// Standard African Creative Investments footer, mirroring the email shell footer.
export const ACI_COMPANY = "African Creative Investments (Pty) Ltd";
export const ACI_DASHBOARD = "dashboard.creativeinvestments.africa";

export interface FooterBrand {
  name?: string | null;
  email?: string | null;
  phone?: string | null;
  website?: string | null;
}

const esc = (v: string) =>
  v.replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&quot;");

export function footerLines(brand: FooterBrand) {
  const name = brand.name || ACI_COMPANY;
  const contact = [brand.phone, brand.email, brand.website?.replace(/^https?:\/\//i, "").replace(/\/$/, "")]
    .filter(Boolean)
    .join(" · ");
  return {
    issued: `Issued by ${ACI_COMPANY} on behalf of ${name}.`,
    operated: `${name} is operated by ${ACI_COMPANY}. Bookings and payments are processed via our secure platform at ${ACI_DASHBOARD}.`,
    contact,
    copyright: `© ${new Date().getFullYear()} ${ACI_COMPANY} — ${name}`,
  };
}

/** Plain (unbranded) HTML footer for ops emails. */
export function plainFooterHtml(brand: FooterBrand): string {
  const f = footerLines(brand);
  const p = (t: string) => `<p style="margin:0 0 6px;font-size:12px;color:#64748b;">${esc(t)}</p>`;
  return `<hr style="border:none;border-top:1px solid #e2e8f0;margin:24px 0 12px;" />${p(f.issued)}${p(f.operated)}${f.contact ? p(f.contact) : ""}${p(f.copyright)}`;
}

export function plainFooterText(brand: FooterBrand): string {
  const f = footerLines(brand);
  return ["", "—", f.issued, f.operated, f.contact, f.copyright].filter((l) => l !== undefined && l !== null).join("\n");
}
